import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/core/services/config.service';
import { CanCloseRepairAssemblyResult } from '../models/CanCloseRepairAssemblyResult';
import { CanCloseRepairResult } from '../models/CanCloseRepairResult';
import { Repair } from '../models/Repair';
import { RepairAssembly } from '../models/RepairAssembly';
import { RepairAssemblyElement } from '../models/RepairAssemblyElement';
import { RepairAssemblySearchResultItem } from '../models/RepairAssemblySearchResultItem';
import { RepairSearchResultItem } from '../models/RepairSearchResultItem';
import { SearchRepairAssembliesCriteria } from '../models/SearchRepairAssembliesCriteria';
import { SearchRepairsCriteria } from '../models/SearchRepairsCriteria';
import { ProvisionForRepairCardData } from '../../inspections/models/ProvisionForRepairCardData';

@Injectable({
  providedIn: 'root'
})
export class RepairService {

  constructor(private http: HttpClient,
    private configService: ConfigService) {

  }

  public storeRepair(data: Repair): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'Repair', data);
  }

  public getRepair(id: number): Observable<Repair> {
    return this.http.get<Repair>(
      this.configService.PortalWebApiUrl + 'Repair/' + id);
  }

   public getRepairProvision(id: number): Observable<ProvisionForRepairCardData> {
    return this.http.get<ProvisionForRepairCardData>(
      this.configService.PortalWebApiUrl + 'Repair/' + id  + '/repairProvision');
  }

  public searchRepairs(criteria: SearchRepairsCriteria): Observable<RepairSearchResultItem[]> {
    return this.http.post<RepairSearchResultItem[]>(
      this.configService.PortalWebApiUrl + 'Repair/search', criteria);
  }

   public searchRepairsForWorkshop(criteria: SearchRepairsCriteria): Observable<RepairSearchResultItem[]> {
    return this.http.post<RepairSearchResultItem[]>(
      this.configService.PortalWebApiUrl + 'Repair/searchForWorkshop', criteria);
  }

  public searchRepairsForDealer(criteria: SearchRepairsCriteria): Observable<RepairSearchResultItem[]> {
    return this.http.post<RepairSearchResultItem[]>(
      this.configService.PortalWebApiUrl + 'Repair/searchForDealer', criteria);
  }

  public canCloseRepair(repairId:number): Observable<CanCloseRepairResult> {
    return this.http.get<CanCloseRepairResult>(
      this.configService.PortalWebApiUrl + 'Repair/canCloseRepair/' + repairId);
  }

  public storeRepairAssembly(data: RepairAssembly): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'RepairAssembly', data);
  }

  public searchRepairAssemblies(criteria: SearchRepairAssembliesCriteria): Observable<RepairAssemblySearchResultItem[]> {
    return this.http.post<RepairAssemblySearchResultItem[]>(
      this.configService.PortalWebApiUrl + 'RepairAssembly/search', criteria);
  }

  public getRepairAssembly(id: number): Observable<RepairAssembly> {
    return this.http.get<RepairAssembly>(
      this.configService.PortalWebApiUrl + 'RepairAssembly/' + id);
  }

  public canCloseRepairAssembly(repairAssemblyId:number): Observable<CanCloseRepairAssemblyResult> {
    return this.http.get<CanCloseRepairAssemblyResult>(
      this.configService.PortalWebApiUrl + 'RepairAssembly/canCloseRepairAssembly/' + repairAssemblyId);
  }

  public addRepairAsemblyElement(data: RepairAssemblyElement): Observable<string> {
    return this.http.post<string>(
      this.configService.PortalWebApiUrl + 'RepairAssembly/addElement', data);
  }

  public deleteRepairAssemblyElement( repairAssemblyId:number, identifier:string,) {
    return this.http.delete(
      this.configService.PortalWebApiUrl +  `RepairAssembly/deleteElement/${repairAssemblyId}/${identifier}`);
  }

  public getRepairAssemblyElements(repairAssemblyId: number): Observable<RepairAssemblyElement[]> {
    return this.http.get<RepairAssemblyElement[]>(
      this.configService.PortalWebApiUrl + `RepairAssembly/getElements/${repairAssemblyId}`);
  }

  
}
